import type { ICellRendererParams } from 'ag-grid-community';
import React from 'react';

export type DefaultTextCellRendererParams = ICellRendererParams & {
  emptyLabel?: string;
  className?: string;
  formatValue?: (value: unknown) => string;
};

/**
 * Minimal text cell renderer with null/undefined/empty fallback.
 * Prefer `cellRendererParams` for `emptyLabel`, `className`, `formatValue`.
 */
const DefaultTextCellRenderer: React.FC<DefaultTextCellRendererParams> = (params) => {
  const empty = params.emptyLabel ?? '-';
  const raw = params.value;
  const text =
    raw === null || raw === undefined || raw === ''
      ? empty
      : params.formatValue
        ? params.formatValue(raw)
        : String(raw);
  return <span className={params.className}>{text}</span>;
};

export default DefaultTextCellRenderer;
